var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-header"},[_c('div',{staticClass:"ed-header__container"},[_c(_vm.header,{tag:"component",attrs:{"sidebarMenu":_vm.sidebarMenu}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }